import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';


export class HttpError {
  static BadRequest = 400;
  static Unauthorized = 401;
  static Forbidden = 403;
  static NotFound = 404;
  static TimeOut = 408;
  static Conflict = 409;
  static InternalServerError = 500;
  static ConnectionRefused = 0;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptorService implements HttpInterceptor {
  constructor(
    private _injector: Injector,
    private messageService: MessageService,
    ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.get('skip-error-interceptor')) {
      req = req.clone({
        headers: req.headers.delete('skip-error-interceptor')
      });
      return next.handle(req);
    }
    return next.handle(req).pipe(catchError(exception => {
      if (exception instanceof HttpErrorResponse) {
        const code = String(exception.status);
        if (exception.status === HttpError.ConnectionRefused) {
          this.messageService.add({
            severity: 'error',
            summary: 'Connection Refused',
            detail: 'It appears our backend is not connecting, please try again later or contact support.',
            life: 5000
          });
        } else if (code.length === 3 && ['4', '5'].indexOf(code.slice(0,1)) !== -1) {
          console.error(code + " error received");
          this.messageService.add({
              severity: 'error',
              summary: code + ' Error',
              detail: 'A ' + code + (code.slice(0, 1) === '5' ? ' server' : ' input') + ' error occurred. ' +
                'Please try again later or contact support.',
              life: 5000
          });
        }
      }
      return throwError(exception);
    }
    ));
  }

}
